/**
 * App
 */

// React
import React from 'react';

// Router
import {BrowserRouter as Router, Switch, Route} from 'react-router-dom';
import Refree from './routes';

// Components
import Auth from './components/Auth';

// UI
import {Container} from '@material-ui/core';
import Root from './pages/root';

class App extends React.Component {
  constructor(props: object) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <Router>
        <Switch>
          <Route exact path="/" component={Root} />
          <Auth>
            <div style={{display: 'flex'}}>
              <Refree/>
            </div>
          </Auth>
        </Switch>
      </Router>
    );
  }
}

export default App;
